import { FC, useEffect, useState } from 'react';
import { Search } from 'lucide-react';
import { Button } from '../ui/button';
import CommandPalette from '../sidebar/CommandPalette';

interface SearchButtonProps {
    onNewProject?: () => void;
    onOpenProject?: () => void;
    onOpenPreview?: () => void;
    setSelectedFile?: (filePath: string) => void;
    activeTab?: any;
    setActiveTab?: (tab: any) => void;
}

const SearchButton: FC<SearchButtonProps> = ({
    onNewProject,
    onOpenProject,
    onOpenPreview,
    setSelectedFile,
    activeTab,
    setActiveTab,
}) => {
    const [isCommandPaletteOpen, setIsCommandPaletteOpen] = useState(false);

    useEffect(() => {
        const handleKeyDown = (e: globalThis.KeyboardEvent) => {
            if ((e.metaKey || e.ctrlKey) && e.key === 'k') {
                e.preventDefault();
                setIsCommandPaletteOpen(true);
            }
        };

        document.addEventListener('keydown', handleKeyDown);
        return () => document.removeEventListener('keydown', handleKeyDown);
    }, []);

    return (
        <>
            <Button
                onClick={() => setIsCommandPaletteOpen(true)}
                variant="ghost"
                size="sm"
                className="flex items-center gap-2 rounded-md px-4 h-7 text-sm text-gray-500 hover:bg-gray-50 border border-gray-200 w-[400px]"
            >
                <Search className="h-3 w-3" />
                <span className="text-[12px]">Search</span>
                <kbd className="pointer-events-none ml-auto inline-flex h-5 items-center gap-1 rounded border border-gray-200 bg-gray-50 px-1.5 font-mono text-[10px] font-medium text-gray-500">
                    <span className="text-xs">⌘</span>
                    <span className="text-[10px] leading-none">K</span>
                </kbd>
            </Button>
            <CommandPalette
                isOpen={isCommandPaletteOpen}
                onClose={() => setIsCommandPaletteOpen(false)}
                onNewProject={onNewProject}
                onOpenProject={onOpenProject}
                onOpenPreview={onOpenPreview}
                setSelectedFile={setSelectedFile}
                activeTab={activeTab}
                setActiveTab={setActiveTab}
            />
        </>
    );
};

export default SearchButton; 